var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _vm.selectedEvent !== null
            ? _c(
                "v-card",
                { attrs: { dark: "" } },
                [
                  _c(
                    "v-card-title",
                    [
                      _vm._v(
                        _vm._s(
                          _vm.selectedEvent.activityDefinitionName || "N/A"
                        ) +
                          " : " +
                          _vm._s(_vm.selectedEvent.id) +
                          " "
                      ),
                      _c("span", { staticClass: "ml-5" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.selectedEvent.parentActivityEventId !== 0
                                ? "Parent Event Id: " +
                                    _vm.selectedEvent.parentActivityEventId
                                : ""
                            )
                        ),
                      ]),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.$emit("clear-selected-event")
                            },
                          },
                        },
                        [_vm._v("x")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-expansion-panels",
                        {
                          model: {
                            value: _vm.activityEventExpansionPanel,
                            callback: function ($$v) {
                              _vm.activityEventExpansionPanel = $$v
                            },
                            expression: "activityEventExpansionPanel",
                          },
                        },
                        [
                          _c(
                            "v-expansion-panel",
                            [
                              _c("v-expansion-panel-header", [
                                _vm._v("Metadata"),
                              ]),
                              _c(
                                "v-expansion-panel-content",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copyMetadata()
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", [_vm._v("content_copy")]),
                                      _vm._v(" Copy Metadata"),
                                    ],
                                    1
                                  ),
                                  _c("pre", [_vm._v(_vm._s(_vm.jsonString))]),
                                  _c("textarea", {
                                    ref: "copyMetadata",
                                    staticClass: "copyText",
                                    domProps: {
                                      value: _vm.selectedEvent.activityMetadata,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-expansion-panel",
                            [
                              _c("v-expansion-panel-header", [
                                _vm._v(" Telemetry "),
                              ]),
                              _c(
                                "v-expansion-panel-content",
                                _vm._l(
                                  _vm.selectedEvent.telemetryItems,
                                  function (telemetry) {
                                    return _c(
                                      "div",
                                      { key: telemetry.createDateTime },
                                      [
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                telemetry.telemetryTypeId === 0
                                                  ? _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          medium: "",
                                                          color: "success",
                                                        },
                                                      },
                                                      [_vm._v("developer_mode")]
                                                    )
                                                  : _vm._e(),
                                                telemetry.telemetryTypeId === 1
                                                  ? _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          medium: "",
                                                          color: "primary",
                                                        },
                                                      },
                                                      [_vm._v("info")]
                                                    )
                                                  : _vm._e(),
                                                telemetry.telemetryTypeId === 2
                                                  ? _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          medium: "",
                                                          color: "warning",
                                                        },
                                                      },
                                                      [_vm._v("warning")]
                                                    )
                                                  : _vm._e(),
                                                telemetry.telemetryTypeId === 3
                                                  ? _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          medium: "",
                                                          color: "error",
                                                        },
                                                      },
                                                      [_vm._v("clear")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.getTelemetryType(
                                                        telemetry.telemetryTypeId
                                                      )
                                                    ) +
                                                    " - " +
                                                    _vm._s(
                                                      new Date(
                                                        telemetry.createDateTime
                                                      ).toLocaleTimeString()
                                                    ) +
                                                    " - " +
                                                    _vm._s(
                                                      _vm.tryFormatJson(
                                                        telemetry.message
                                                      )
                                                    )
                                                ),
                                              ],
                                              1
                                            ),
                                            telemetry.exception
                                              ? _c(
                                                  "v-col",
                                                  { attrs: { cols: "12" } },
                                                  [
                                                    _c("span", [
                                                      _vm._v("Exception: "),
                                                    ]),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          telemetry.exception
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _c("hr"),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }